import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { RetoChallenge } from "@/components/reto/RetoChallenge";

export const Route = createFileRoute("/reto")({
  head: () => ({
    meta: [
      { title: "¿Crees conocer México? — Reto interactivo Mostrando México" },
      {
        name: "description",
        content:
          "Responde el reto cultural de México y desbloquea códigos de descuento TRAVEL10 y TRAVEL15 para tu próxima experiencia.",
      },
      { property: "og:title", content: "¿Crees conocer México?" },
      {
        property: "og:description",
        content: "Reto interactivo con IA y descuentos exclusivos.",
      },
    ],
    links: [{ rel: "canonical", href: "https://www.mostrandomexico.mx/reto" }],
  }),
  component: RetoPage,
});

function RetoPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <RetoChallenge />
      </main>
      <SiteFooter />
    </div>
  );
}
